import styled from "styled-components";

export const SignUpFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-content: center;

  @media (max-width: 450px) {
    flex-direction: column;
    justify-content: center;
    align-content: center;
  }

  h2 {
    margin: 10px 0;
  }
`;
